var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiAssist = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.083 13.724 2.78 12.138a.619.619 0 0 1 0-1.161l4.304-1.586L8.67 5.087a.619.619 0 0 1 1.161 0l1.586 4.304 4.304 1.586a.618.618 0 0 1 0 1.16l-4.304 1.587-1.586 4.304a.618.618 0 0 1-1.16 0l-1.587-4.304ZM14.25 1.557v3.75M18 5.932v2.5M12.375 3.432h3.75M16.75 7.182h2.5",
  stroke: "currentColor",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiAssist);
export default ForwardRef;